import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFilter } from "../../../../context/FilterContext";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import moment from "moment";
import { post } from "../../../helpers/api_helper";
import {
  POST_CreditNoteCancel,
  POST_CreditNoteEmailSend,
  POST_CreditNoteExport,
  POST_CreditNoteWhatsAppMessageSend,
  POST_EInvoice_Generate,
  POST_GetCreditNoteList,
  POST_GetCreditNotePrintHTMLContents,
  POST_GetCreditNoteSendEmailDetail,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLListAJAX,
} from "../../../helpers/url_helper";
import { SVGICON } from "../../../constant/theme";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import {
  cleanCsvString,
  customConfirmDialog,
  errorMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";

const CreditNote = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "credit-note" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "credit-note" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "credit-note" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "credit-note" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [creditNoteList, setCreditNoteList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      CreditNoteNo:
        filter && filter?.page == "credit-note" ? filter?.CreditNoteNo : "",
      FromDate:
        filter && filter?.page == "credit-note" ? filter?.FromDate : new Date(),
      ToDate:
        filter && filter?.page == "credit-note" ? filter?.ToDate : new Date(),
      InvoiceNo:
        filter && filter?.page == "credit-note" ? filter?.InvoiceNo : "",
      CustomerIDEncrypted:
        filter && filter?.page == "credit-note"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "credit-note" ? filter?.CustomerName : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      CreditNoteNo,
      FromDate,
      ToDate,
      InvoiceNo,
      CustomerIDEncrypted,
      CustomerName,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      CreditNoteNo: "",
      InvoiceNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "credit-note",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      CreditNoteNo: CreditNoteNo,
      InvoiceNo: InvoiceNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Status: -1,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreditNoteNo: CreditNoteNo,
      InvoiceNo: InvoiceNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    await post(POST_GetCreditNoteList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCreditNoteList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Status: -1,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreditNoteNo: CreditNoteNo,
      InvoiceNo: InvoiceNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    post(POST_CreditNoteExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const [showCancelCreditNoteModal, setShowCancelCreditNoteModal] =
    useState(false);

  const validationSchemaCancelCreditNote = Yup.object().shape({
    CancelReason: Yup.string()
      .trim()
      .required("Cancel Reason is required field"),
  });

  const formikCancelCreditNote = useFormik({
    validationSchema: validationSchemaCancelCreditNote,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelCreditNote(values, formikHelpers),
    initialValues: {
      CreditNoteIDEncrypted: "",
      CreditNoteNo: "",
      CancelReason: "",
      EInvoiceIRNNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikCancelCreditNote;

  const cancelCreditNote = (creditNoteID, creditNoteNo, eInvoice_irnNo) => {
    formikCancelCreditNote.resetForm();
    formikCancelCreditNote.setFieldValue("CreditNoteNo", creditNoteNo);
    formikCancelCreditNote.setFieldValue("EInvoiceIRNNo", eInvoice_irnNo);
    formikCancelCreditNote.setFieldValue("CreditNoteIDEncrypted", creditNoteID);
    setShowCancelCreditNoteModal(true);
  };

  const handleValidSubmitCancelCreditNote = (values) => {
    setIsLoading(true);
    post(POST_CreditNoteCancel, {
      CreditNoteIDEncrypted: values?.CreditNoteIDEncrypted,
      CancelledReason: values?.CancelReason,
      ModifiedByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EInvoiceIRNNo: values?.EInvoiceIRNNo,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
          setShowCancelCreditNoteModal(false);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printCreditNote = async (creditNoteID) => {
    setIsLoading(true);
    await post(POST_GetCreditNotePrintHTMLContents, {
      CreditNoteIDEncrypted: creditNoteID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFrameCreditNote");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showSendEmailCreditNoteModal, setShowSendEmailCreditNoteModal] =
    useState(false);
  const [emailContactPersonOptions, setEmailContactPersonOptions] = useState(
    []
  );

  const validationSchemaSendEmailCreditNote = Yup.object().shape({});

  const formikSendEmailCreditNote = useFormik({
    validationSchema: validationSchemaSendEmailCreditNote,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendEmailCreditNote(values, formikHelpers),
    initialValues: {
      CreditNoteIDEncrypted: "",
      CreditNoteNo: "",
      emailListOfProjectContactPerson: [],
      emailListOfAdditionalContactPerson: [],
      emailAdditionalEmailID: "",
      emailCustomerIDEncrypted: "",
      emailCustomerName: "",
      emailCustomerContactPersonIDEncrypted: "",
      emailContactPerson: "",
      emailDesignation: "",
      emailMobileNo: "",
      emailEmailID: "",
      emailContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      emailListOfProjectContactPerson,
      emailListOfAdditionalContactPerson,
      emailCustomerIDEncrypted,
      emailCustomerName,
      emailCustomerContactPersonIDEncrypted,
      emailContactPerson,
      emailDesignation,
      emailMobileNo,
      emailEmailID,
      emailContactPersonID,
    },
  } = formikSendEmailCreditNote;

  const openSendEmailCreditNoteDialog = async (creditNoteID, creditNoteNo) => {
    formikSendEmailCreditNote.resetForm();
    formikSendEmailCreditNote.setFieldValue("CreditNoteNo", creditNoteNo);
    formikSendEmailCreditNote.setFieldValue(
      "CreditNoteIDEncrypted",
      creditNoteID
    );
    setIsLoading(true);
    await post(POST_GetCreditNoteSendEmailDetail, {
      CreditNoteIDEncrypted: creditNoteID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendEmailCreditNote.setFieldValue(
            "emailListOfProjectContactPerson",
            response?.ListOfProjectContactPerson
          );
        }
        setShowSendEmailCreditNoteModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCustomer_email = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (emailCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(emailCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);
      formikSendEmailCreditNote.setFieldValue(
        "emailCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendEmailCreditNote.setFieldValue("emailContactPerson", "");
      formikSendEmailCreditNote.setFieldValue("emailDesignation", "");
      formikSendEmailCreditNote.setFieldValue("emailMobileNo", "");
      formikSendEmailCreditNote.setFieldValue("emailEmailID", "");
      formikSendEmailCreditNote.setFieldValue("emailContactPersonID", "");
    }
  }, [emailCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_email = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmailContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const addAdditionalContactPerson_email = () => {
    if (emailCustomerIDEncrypted && emailCustomerContactPersonIDEncrypted) {
      if (
        emailListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            emailCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendEmailCreditNote.setFieldValue(
          "emailListOfAdditionalContactPerson",
          [
            ...emailListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: emailCustomerName,
              CustomerContactPersonIDEncrypted:
                emailCustomerContactPersonIDEncrypted,
              ContactPerson: emailContactPerson,
              Designation: emailDesignation,
              MobileNo: emailMobileNo,
              EmailID: emailEmailID,
              ContactPersonID: emailContactPersonID,
            },
          ]
        );
        formikSendEmailCreditNote.setFieldValue(
          "emailCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendEmailCreditNote.setFieldValue("emailContactPerson", "");
        formikSendEmailCreditNote.setFieldValue("emailDesignation", "");
        formikSendEmailCreditNote.setFieldValue("emailMobileNo", "");
        formikSendEmailCreditNote.setFieldValue("emailEmailID", "");
        formikSendEmailCreditNote.setFieldValue("emailContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!emailCustomerIDEncrypted) {
        formikSendEmailCreditNote.setFieldError(
          "emailCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendEmailCreditNote.setFieldTouched(
          "emailCustomerIDEncrypted",
          true
        );
      }
      if (!emailCustomerContactPersonIDEncrypted) {
        formikSendEmailCreditNote.setFieldError(
          "emailCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendEmailCreditNote.setFieldTouched(
          "emailCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const handleValidSubmitSendEmailCreditNote = async (values) => {
    if (values?.CreditNoteIDEncrypted) {
      let listOfAdditionalEmails = values?.emailAdditionalEmailID?.trim()
        ? cleanCsvString(values?.emailAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.emailListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.emailListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!"
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendEmailCreditNote.setFieldError(
            "emailAdditionalEmailID",
            "Please check it contains invalid email address"
          );
          formikSendEmailCreditNote.setFieldTouched(
            "emailAdditionalEmailID",
            true
          );
        } else {
          setIsLoading(true);

          let emailCsv = "";
          Promise.all(
            values?.emailListOfProjectContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.emailListOfAdditionalContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            listOfAdditionalEmails?.map((email) => {
              emailCsv = emailCsv + email + ":::" + 0 + ", ";
            }),
            (emailCsv = cleanCsvString(emailCsv))
          );

          setIsLoading(true);
          await post(POST_CreditNoteEmailSend, {
            CreditNoteIDEncrypted: values?.CreditNoteIDEncrypted,
            BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
            CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
            EmailIDs: emailCsv,
          })
            .then((response) => {
              if (response?.IsSuccess) {
                successMessage(response?.Message);
                setShowSendEmailCreditNoteModal(false);
                getData(currentPage, currentSizePerPage);
              } else {
                errorMessage(response?.Message);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const generateEInvoice = (creditNoteID) => {
    setIsLoading(true);
    post(POST_EInvoice_Generate, {
      EInvoiceType: 2, // 1 - Invoice, 2 - Credit Note, 3 - Debit Note
      IDEncrypted: creditNoteID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [
    showSendWhatsAppMessageCreditNoteModal,
    setShowSendWhatsAppMessageCreditNoteModal,
  ] = useState(false);

  const openCreditNoteWhatsAppMessageDialog = async (
    creditNoteID,
    creditNoteNo
  ) => {
    formikSendWhatsAppMessageCreditNote.resetForm();
    formikSendWhatsAppMessageCreditNote.setFieldValue(
      "CreditNoteNo",
      creditNoteNo
    );
    formikSendWhatsAppMessageCreditNote.setFieldValue(
      "CreditNoteIDEncrypted",
      creditNoteID
    );
    setIsLoading(true);
    await post(POST_GetCreditNoteSendEmailDetail, {
      CreditNoteIDEncrypted: creditNoteID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendWhatsAppMessageCreditNote.setFieldValue(
            "WAPMListOfProjectContactPerson",
            //response?.ListOfProjectContactPerson
            response?.ListOfProjectContactPerson?.filter(
              (item) => item.MobileNo !== ""
            )?.map((x) => ({
              ...x,
              IsSelected: false,
            }))
          );
        }
        setShowSendWhatsAppMessageCreditNoteModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaSendWhatsAppMessageCreditNote = Yup.object().shape({});

  const formikSendWhatsAppMessageCreditNote = useFormik({
    validationSchema: validationSchemaSendWhatsAppMessageCreditNote,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendWhatsAppMessageCreditNote(values, formikHelpers),
    initialValues: {
      CreditNoteIDEncrypted: "",
      CreditNoteNo: "",
      WAPMListOfProjectContactPerson: [],
      WAPMListOfAdditionalContactPerson: [],
      WAPMAdditionalEmailID: "",
      WAPMCustomerIDEncrypted: "",
      WAPMCustomerName: "",
      WAPMCustomerContactPersonIDEncrypted: "",
      WAPMContactPerson: "",
      WAPMDesignation: "",
      WAPMMobileNo: "",
      WAPMEmailID: "",
      WAPMAdditionalMobileNo: "",
      WAPMContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      WAPMListOfProjectContactPerson,
      WAPMListOfAdditionalContactPerson,
      WAPMCustomerIDEncrypted,
      WAPMCustomerName,
      WAPMCustomerContactPersonIDEncrypted,
      WAPMContactPerson,
      WAPMDesignation,
      WAPMMobileNo,
      WAPMEmailID,
      WAPMAdditionalMobileNo,
      WAPMContactPersonID,
    },
  } = formikSendWhatsAppMessageCreditNote;

  const handleValidSubmitSendWhatsAppMessageCreditNote = async (values) => {
    if (values?.CreditNoteIDEncrypted) {
      let additionalMobileNumbers = values?.WAPMAdditionalMobileNo?.trim();

      if (values?.WAPMAdditionalMobileNo) {
        //const isValidFormat = /^[0-9]+(,[0-9]+)*$/.test(additionalMobileNumbers);
        const isValidFormat = /^(\d{10})(,\d{10})*$/.test(
          additionalMobileNumbers
        );
        if (!isValidFormat) {
          errorMessage(
            "Please enter valid 10-digit mobile numbers separated by commas."
          );
          return;
        }
      }

      let listOfAdditionalMobileNo = additionalMobileNumbers
        ? cleanCsvString(additionalMobileNumbers)?.split(",")
        : [];

      if (
        values?.WAPMListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.WAPMListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalMobileNo?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional mobile no to send message!"
        );
      } else {
        setIsLoading(true);

        let MobileNoCsv = "";
        Promise.all(
          values?.WAPMListOfProjectContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAPMListOfAdditionalContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          listOfAdditionalMobileNo?.map((mno) => {
            MobileNoCsv = MobileNoCsv + mno + ":::" + 0 + ", ";
          }),
          (MobileNoCsv = cleanCsvString(MobileNoCsv))
        );

        let payload = {
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CreditNoteIDEncrypted: values?.CreditNoteIDEncrypted,
          CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
          MobileNos: MobileNoCsv,
        };

        // setIsLoading(false);
        // console.log("payload", values?.WAPMsscAdditionalMobileNo);
        // return;

        await post(POST_CreditNoteWhatsAppMessageSend, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setShowSendWhatsAppMessageCreditNoteModal(false);
              getData(currentPage, currentSizePerPage);
            } else {
              errorMessage(response?.Message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const addAdditionalContactPerson_WAPM = () => {
    if (WAPMCustomerIDEncrypted && WAPMCustomerContactPersonIDEncrypted) {
      if (
        WAPMListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            WAPMCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMListOfAdditionalContactPerson",
          [
            ...WAPMListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: WAPMCustomerName,
              CustomerContactPersonIDEncrypted:
                WAPMCustomerContactPersonIDEncrypted,
              ContactPerson: WAPMContactPerson,
              Designation: WAPMDesignation,
              MobileNo: WAPMMobileNo,
              EmailID: WAPMEmailID,
              ContactPersonID: WAPMContactPersonID,
            },
          ]
        );
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMContactPerson",
          ""
        );
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMDesignation",
          ""
        );
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMemailMobileNo",
          ""
        );
        formikSendWhatsAppMessageCreditNote.setFieldValue("WAPMEmailID", "");
        formikSendWhatsAppMessageCreditNote.setFieldValue(
          "WAPMContactPersonID",
          ""
        );
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!WAPMCustomerIDEncrypted) {
        formikSendWhatsAppMessageCreditNote.setFieldError(
          "WAPMCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendWhatsAppMessageCreditNote.setFieldTouched(
          "WAPMCustomerIDEncrypted",
          true
        );
      }
      if (!WAPMCustomerContactPersonIDEncrypted) {
        formikSendWhatsAppMessageCreditNote.setFieldError(
          "WAPMCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendWhatsAppMessageCreditNote.setFieldTouched(
          "WAPMCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  useEffect(() => {
    if (WAPMCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(WAPMCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);

      formikSendWhatsAppMessageCreditNote.setFieldValue(
        "WAPMCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendWhatsAppMessageCreditNote.setFieldValue(
        "WAPMContactPerson",
        ""
      );
      formikSendWhatsAppMessageCreditNote.setFieldValue("WAPMDesignation", "");
      formikSendWhatsAppMessageCreditNote.setFieldValue("WAPMMobileNo", "");
      formikSendWhatsAppMessageCreditNote.setFieldValue("WAPMEmailID", "");
      formikSendWhatsAppMessageCreditNote.setFieldValue(
        "WAPMContactPersonID",
        ""
      );
    }
  }, [WAPMCustomerIDEncrypted]);

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Credit Note</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 63 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 63 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-credit-note"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Credit Note
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Credit Note No"
                              name="CreditNoteNo"
                              placeholder={"Search Credit Note No"}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">Credit Note Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Invoice No"
                              name="InvoiceNo"
                              placeholder={"Search Invoice No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="CreditNote-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="CreditNote-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="6%" style={{ minWidth: "120px" }}></th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreditNoteNo");
                          }}
                        >
                          Credit Note No{" "}
                          <span className="ml-1">
                            {sortBy == "CreditNoteNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreditNoteDate");
                          }}
                        >
                          Credit Note Date{" "}
                          <span className="ml-1">
                            {sortBy == "CreditNoteDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "25%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceNo");
                          }}
                        >
                          Invoice No{" "}
                          <span className="ml-1">
                            {sortBy == "InvoiceNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("NetAmount");
                          }}
                        >
                          Net Amount{" "}
                          <span className="ml-1">
                            {sortBy == "NetAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "6%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("WhatsAppMessageSend");
                          }}
                        >
                          WhatsApp Send{" "}
                          <span className="ml-1">
                            {sortBy == "WhatsAppMessageSend" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.Permissions?.Email == 1 ? (
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("MailSent");
                            }}
                          >
                            Mail Send{" "}
                            <span className="ml-1">
                              {sortBy == "MailSent" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedBy");
                          }}
                        >
                          Created By{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedOn");
                          }}
                        >
                          Created On{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedOn" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {creditNoteList?.length > 0 ? (
                        creditNoteList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 63 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/edit-credit-note/${window.btoa(
                                    item.CreditNoteIDEncrypted
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Edit"
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              ) : (
                                ""
                              )}
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Print"
                                onClick={() => {
                                  printCreditNote(item.CreditNoteIDEncrypted);
                                }}
                              >
                                {SVGICON.Printer}
                              </Link>
                              {(AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 63 && x?.IsDelete
                                )?.length > 0) &&
                              (item.EInvoiceIRNNo == "" ||
                                (item.EInvoiceIRNNo != "" &&
                                  item.EInvoiceCanBeCancelled == true)) ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Cancel"
                                  onClick={() => {
                                    cancelCreditNote(
                                      item.CreditNoteIDEncrypted,
                                      item.CreditNoteNo,
                                      item.EInvoiceIRNNo
                                    );
                                  }}
                                >
                                  {SVGICON.Cancel}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.Permissions?.Email == 1 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Send Email"
                                  onClick={() => {
                                    openSendEmailCreditNoteDialog(
                                      item.CreditNoteIDEncrypted,
                                      item.CreditNoteNo
                                    );
                                  }}
                                >
                                  {SVGICON.SendEmail}
                                </Link>
                              ) : (
                                ""
                              )}
                              {(AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 63 && (x?.IsEdit || x.IsAdd)
                                )?.length > 0) &&
                              AuthUser?.EInvoiceApplicable == true &&
                              item.GenerateEInvoice == false &&
                              item.GSTNo ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Generate E-Invoice"
                                  onClick={(e) => {
                                    customConfirmDialog(
                                      "Generate E-Invoice",
                                      `Do you want to generate ${item.CreditNoteNo} E-Invoice?`,
                                      () => {
                                        generateEInvoice(
                                          item.CreditNoteIDEncrypted
                                        );
                                      },
                                      true
                                    );
                                  }}
                                >
                                  {SVGICON.Invoice}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType == 1 &&
                              AuthUser?.Permissions?.Whatsup == 1 &&
                              formsList?.filter(
                                (x) =>
                                  x?.FormID == 81 && (x?.IsAdd || x?.IsEdit)
                              )?.length > 0 ? (
                                <>
                                  <Link
                                    className="icon-box icon-box-md me-1"
                                    title="Send Credit Note in WhatsApp"
                                    onClick={() => {
                                      openCreditNoteWhatsAppMessageDialog(
                                        item.CreditNoteIDEncrypted,
                                        item.CreditNoteNo
                                      );
                                    }}
                                  >
                                    {SVGICON.WhatsApp}
                                  </Link>
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.CreditNoteNo}
                              {AuthUser?.EInvoiceApplicable == true &&
                                item.GSTNo && (
                                  <>
                                    <br></br>
                                    {item.CancelEInvoice == true ? (
                                      <span className="fs-12 text-danger">
                                        E-Invoice: Cancelled
                                      </span>
                                    ) : item.GenerateEInvoice == true ? (
                                      <span className="fs-12 text-primary">
                                        E-Invoice: Done
                                      </span>
                                    ) : (
                                      <span className="fs-12 text-danger">
                                        E-Invoice: Pending
                                      </span>
                                    )}
                                  </>
                                )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.CreditNoteDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.CustomerName}
                              {item.GSTNo && (
                                <>
                                  <br></br>
                                  <span className="fs-12 text-primary">
                                    {item.GSTNo}
                                  </span>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InvoiceNo}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.NetAmount}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                              }}
                            >
                              {item.WhatsAppMessageSend == true ? (
                                <>
                                  Yes <br></br>
                                  {item.WhatsAppMessageSendBy}
                                  <br></br>
                                  {item.WhatsAppMessageSendDate}
                                </>
                              ) : (
                                "No"
                              )}
                            </td>
                            {AuthUser?.Permissions?.Email == 1 ? (
                              <td style={{ verticalAlign: "top" }}>
                                {item.MailSent == true ? (
                                  <>
                                    Yes <br></br>
                                    {item.MailSentBy}
                                    <br></br>
                                    {item.MailSentDate}
                                  </>
                                ) : (
                                  "No"
                                )}
                              </td>
                            ) : (
                              ""
                            )}
                            <td style={{ verticalAlign: "top" }}>
                              {item.CreatedBy}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.CreatedDate}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <hr className="mt-0 mb-0"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showCancelCreditNoteModal}
            onHide={setShowCancelCreditNoteModal}
            size="lg"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCancelCreditNote}>
                <Form onSubmit={formikCancelCreditNote.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Cancel Credit Note -{" "}
                      {formikCancelCreditNote.values.CreditNoteNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowCancelCreditNoteModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={12}>
                        <Field
                          label="Cancel Reason"
                          name="CancelReason"
                          placeholder={"Cancel Reason"}
                          component={CustomInput}
                          maxLength={500}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowCancelCreditNoteModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendEmailCreditNoteModal}
            onHide={setShowCancelCreditNoteModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendEmailCreditNote}>
                <Form onSubmit={formikSendEmailCreditNote.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Credit Note Email -{" "}
                      {formikSendEmailCreditNote.values.CreditNoteNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowSendEmailCreditNoteModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {emailListOfProjectContactPerson?.length > 0 ? (
                              emailListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendEmailCreditNote.setFieldValue(
                                            `emailListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="emailCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={emailCustomerName}
                          labelFieldName="emailCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="emailCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendEmailCreditNote.setFieldValue(
                              "emailCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendEmailCreditNote.setFieldValue(
                              "emailContactPerson",
                              e?.label ?? ""
                            );
                            formikSendEmailCreditNote.setFieldValue(
                              "emailDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendEmailCreditNote.setFieldValue(
                              "emailMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendEmailCreditNote.setFieldValue(
                              "emailEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendEmailCreditNote.setFieldValue(
                              "emailContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_email();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {emailListOfAdditionalContactPerson?.length >
                                0 ? (
                                  emailListOfAdditionalContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedACP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendEmailCreditNote.setFieldValue(
                                                `emailListOfAdditionalContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Additional Email"
                          name="emailAdditionalEmailID"
                          placeholder={"Enter Additional Email"}
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-envelope"></i> Send Email
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowSendEmailCreditNoteModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendWhatsAppMessageCreditNoteModal}
            onHide={setShowSendWhatsAppMessageCreditNoteModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendWhatsAppMessageCreditNote}>
                <Form
                  onSubmit={formikSendWhatsAppMessageCreditNote.handleSubmit}
                >
                  <Modal.Header>
                    <Modal.Title>
                      Credit Note Send WhatsApp Message -{" "}
                      {formikSendWhatsAppMessageCreditNote.values.CreditNoteNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSendWhatsAppMessageCreditNoteModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {WAPMListOfProjectContactPerson?.length > 0 ? (
                              WAPMListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendWhatsAppMessageCreditNote.setFieldValue(
                                            `WAPMListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="WAPMCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={WAPMCustomerName}
                          labelFieldName="WAPMCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="WAPMCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMContactPerson",
                              e?.label ?? ""
                            );
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                              "WAPMContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_WAPM();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAPMListOfAdditionalContactPerson?.length >
                                0 ? (
                                  WAPMListOfAdditionalContactPerson?.filter(
                                    (x) => x.MobileNo !== ""
                                  ).map((item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedACP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikSendWhatsAppMessageCreditNote.setFieldValue(
                                              `WAPMListOfAdditionalContactPerson[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.CustomerName}</td>
                                      <td>{item?.ContactPerson}</td>
                                      <td>{item?.Designation}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          //type="number"
                          label="Additional Mobile No"
                          name="WAPMAdditionalMobileNo"
                          placeholder={
                            "Enter Additional Mobile No like 1234567890,0987654321"
                          }
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fab la-whatsapp me-2" /> Send Message
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSendWhatsAppMessageCreditNoteModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFrameCreditNote`}
          title="Credit Note"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default CreditNote;
